import React from 'react'

import ContTestSetting from './containers/ContTestSetting'
import ContTestHeader from './containers/ContTestHeader'
import ContTestCriteria from './containers/ContTestCriteria'
import ContWaitSetting from './containers/ContWaitSetting'
import ContResultSummary from './containers/ContResultSummary'
import { ReducerContextProvider } from './reducers/reducerContext.js';

class AppTestScreen extends React.Component {

	render() {
		return (
			<ReducerContextProvider>
				<ContTestHeader />
				<ContTestSetting />
				<div className="row">
					<div className="col col-lg-8 col-12">
						<ContTestCriteria />
					</div>
					<div className="col col-lg-4 col-12">
						<ContWaitSetting />
						<ContResultSummary />
					</div>
				</div>
			</ReducerContextProvider>
		);
	}

}

export default (AppTestScreen);
